import _ from "lodash";
import {
  rfcValidation,
  phoneValidation
} from "../../Utils/validation-patterns";

// Fields with additional validation required
const avFields = ["rfc", "phone_number"];

/**
 * Function for additional fields validation
 * @param {string} field Current field name
 * @param {string|number|boolean} value Current field value
 * @param {Object} errors Form validation errors
 */
const additionalValidations = (field, value, errors) => {
  if (field === "rfc") {
    if (!rfcValidation(value)) {
      _.assign(errors, { [field]: "Ingresa un RFC válido" });
    } else {
      delete errors[field];
    }
  }

  if (field === "phone_number") {
    if (!phoneValidation(value)) {
      _.assign(errors, { [field]: "Ingresa un RFC válido" });
    } else {
      delete errors[field];
    }
  }
};

/**
 * Function for field values validation.
 * @param {string} field Current field name
 * @param {string|number|boolean} value Current field value
 * @param {Object} errors Form validation errors
 * @param {Object} formValues Current field values
 * @param {Array} formFields All form fields
 * @param {number} currentStep Step form
 */
const validateFields = (
  field,
  value,
  errors,
  formValues,
  formFields,
  currentStep
) => {
  let disabledSubmit = true;
  let requiredFieldsHaveValue = true;

  const parsedFields = _.map(formFields, item => {
    const tempItem = { ...item };
    const tempObj = { ...tempItem.value };
    for (var propName in tempObj) {
      if (tempObj[propName] === null || tempObj[propName] === undefined) {
        delete tempObj[propName];
      }
    }

    tempItem.name = tempItem.fieldName;
    tempItem.value = _.values(_.omit(tempObj, ["__typename"]))[0];
    return tempItem;
  });

  _.map(parsedFields, formField => {
    if (formField.required) {
      if (field === formField.name) {
        if (!value) {
          _.assign(errors, { [field]: "Requerido" });
        } else if (_.includes(avFields, field)) {
          additionalValidations(field, value, errors);
        } else {
          delete errors[field];
        }
      }

      if (!formValues[formField.name] || !formValues[formField.name].length) {
        requiredFieldsHaveValue = requiredFieldsHaveValue && false;
      }
    }
  });

  if (_.isEmpty(errors) && requiredFieldsHaveValue) {
    disabledSubmit = false;
  }

  return disabledSubmit;
};

export default validateFields;



// WEBPACK FOOTER //
// ./src/Components/Services/validations.js